import { useState } from "react";
import { Link } from "react-router-dom";
import KapeiLogo from "@/components/KapeiLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) {
      setErr(e2.response?.data?.detail || "No se pudo enviar el email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto flex min-h-screen max-w-md flex-col px-6 py-6">
        <Link to="/"><KapeiLogo className="mb-8" /></Link>

        <h1 className="mb-2 text-4xl font-black tracking-tight text-slate-900">
          Recuperar contraseña
        </h1>

        <p className="mb-8 text-base text-slate-600">
          Escribe tu email y te enviaremos un enlace para crear una nueva contraseña.
        </p>

        {sent ? (
          <div className="rounded-2xl border-2 border-lime-200 bg-lime-50 p-5">
            <p className="font-bold text-lime-900">
              Si el email existe, recibirás un enlace de recuperación.
            </p>
            <p className="mt-2 text-sm text-lime-800">
              Revisa también la carpeta de spam o promociones.
            </p>
            <Link to="/login" className="mt-5 inline-block font-extrabold text-[#4d7c0f] underline">
              Volver a iniciar sesión
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="flex flex-col gap-5">
            <div>
              <Label className="text-sm font-bold uppercase tracking-widest text-slate-700">
                Email
              </Label>
              <Input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 h-14 rounded-xl border-2 border-slate-300 px-4 text-lg"
                placeholder="tu@email.com"
              />
            </div>

            {err && (
              <div className="rounded-xl bg-red-50 p-3 text-sm font-bold text-red-700">
                {err}
              </div>
            )}

            <Button
              data-testid="forgot-submit"
              type="submit"
              disabled={loading}
              className="kapei-btn-huge bg-[#4d7c0f] text-white hover:bg-[#3f6212]"
            >
              {loading ? "Enviando…" : "Enviar enlace"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
